import * as actionTypes from "./actionTypes";
import { setLoader, unSetLoader, setErrorMessage } from "./appActions";
import Blob from "blob";
import { billing } from "store/requests";

export const getERAList = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getERAList",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
export const getERAClaimList = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getERAClaimList",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const initiateERAPosting = async (payload) => {
  try {
    let { data } = await billing({
      url: "/initiateERAPosting",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getERADetails = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getERADetails",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getChargeLineTransactions = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getChargeLineTransactions",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const updateERADepositDate = async (payload) => {
  try {
    let { data } = await billing({
      url: "/updateERADepositDate",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getERAClaimDetails = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getERAClaimDetails",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getEraPdf = (payload, openInNewTab = true) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let response = await billing({
        url: "/getERAPDF",
        payload,
        data: {
          responseType: "blob",
        },
      });
      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      if (openInNewTab) window.open(fileURL);
      dispatch(storeEraPdf(response.data));
      dispatch(unSetLoader());
      if (!openInNewTab) return fileURL;
    } catch (error) {
      dispatch(
        setErrorMessage(
          error?.response?.data?.error
            ? error.response.data.error
            : error.message
        )
      );
      dispatch(unSetLoader());
    }
  };
};

export const storeEraDetails = (eraArr) => {
  return {
    type: actionTypes.STORE_ERA_LIST,
    payload: eraArr,
  };
};

export const storeCurrentEra = (eraData) => {
  return {
    type: actionTypes.STORE_ERA_CURRENT,
    payload: eraData,
  };
};

export const storeEraPdf = (pdf) => {
  return {
    type: actionTypes.STORE_ERA_PDF,
    payload: pdf,
  };
};

export const setEraModal = (value) => {
  return {
    type: actionTypes.SET_ERA_MODAL,
    payload: value,
  };
};

export const addERA = async (era_data, file) => {
  console.log("era_data: ", era_data);
  const payload = new FormData();
  // ! ADD practice_id
  payload.append("request_json", JSON.stringify(era_data));
  if (file) payload.append("file", file);
  try {
    let { data } = await billing({
      url: "/addERA",
      payload,
      addPracticeId: false,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getChargeEntryERAs = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getChargeEntryERAs",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getRemarkCodes = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getRemarkCodes",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getAdjustmentCodes = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getAdjustmentCodes",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getPaidAmountByPayerByMonth = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getPaidAmountByPayerByMonth",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getPaidAmountByProviderByMonth = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getPaidAmountByProviderByMonth",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getAdjCodeCountSummary = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getAdjCodeCountSummary",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getAdjCodeCountByPayer = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getAdjCodeCountByPayer",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getAdjCodeCountByProvider = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getAdjCodeCountByProvider",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const downloadDOSPatienBillsCombinedDoc = async (payload) => {
  try {
    let response = await billing({
      url: "/downloadDOSPatienBillsCombinedDoc",
      payload,
      data: { responseType: "blob" },
    });
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getERAClaimListByAdjCode = async (payload) => {
  try {
    let { data } = await billing({
      url: "/getERAClaimListByAdjCode",
      payload,
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getERAReferenceData = () => {
  return async (dispatch, getStore) => {
    const authData = getStore().auth.authData;
    try {
      let { data } = await billing({
        url: "/getERAReferenceData",
      });
      const updatedData = {
        ...data,
        "Adjustment Group": data["Adjustment Group"].map((d) => ({
          ...d,
          code_description: d.code_value + " : " + d.code_description,
        })),
        "Adjustment Code": data["Adjustment Code"].map((d) => ({
          ...d,
          fullText: d.code_value + " : " + d.code_description,
        })),
      };
      const newAuthData = { ...authData, ...updatedData };
      dispatch({
        type: actionTypes.AUTH_SUCCESS,
        authData: newAuthData,
        error: null,
      });
      localStorage.setItem("auth_data", JSON.stringify(newAuthData));
      return data;
    } catch (error) {
      console.error(error);
    }
  };
};
